import React from 'react';
import CountUpCounter from './CountUpCounter';
import { Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import { useGetFacultyStatisticsQuery } from '../../../redux/services/faculty_statistics.jsx';

const Counter = () => {
  const { t } = useTranslation();
  const { data: statistics } = useGetFacultyStatisticsQuery();

  // keys match the rows of the faculty_statistics table
  const items = [
    { key: 'students', icon: 'fa-graduation-cap', label: t('študentov') },
    { key: 'teachers', icon: 'fa-users', label: t('učiteľov') },
    { key: 'partners', icon: 'fa-handshake', label: t('partnerov') },
  ].filter((item) => Number.isFinite(statistics?.[item.key]));

  // render the counters only once the values are loaded, so the count-up animation ends at the real value
  if (items.length === 0) {
    return null;
  }

  return (
    <div className="counter-comp-wrapper">
      <Row align="center">
        <Col
          xxl={{ span: 16 }}
          lg={{ span: 18 }}
          md={{ span: 20 }}
          sm={{ span: 24 }}
          span={24}
        >
          <Row align="center">
            {items.map((item) => (
              <Col
                key={item.key}
                span={24}
                sm={{ span: 24 }}
                md={{ span: 24 / items.length }}
                className="counter-card-wrapper"
              >
                <div className="counter-icon">
                  <i className={`fa ${item.icon}`} />
                </div>
                <CountUpCounter countNumber={statistics[item.key]} />
                <div className="description">{item.label}</div>
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default Counter;
